import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import GovtApiCards from "./GovtApiCards";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;
const Govt_Image = `${digitalOceanURL}/Sector/Govt_API_Image.png`;

const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://hirestar.io/govt-api",
      url: "https://hirestar.io/govt-api",
      name: "Secure Employee Verification Using Government APIs",
      description:
        "Streamline hiring with HireStar.io: real-time background verification using secure government APIs, AI insights, and blockchain-backed trust.",
      publisher: {
        "@type": "Organization",
        name: "HireStar.io",
        url: "https://hirestar.io",
        logo: {
          "@type": "ImageObject",
          url: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
        },
      },
    },
    {
      "@type": "Service",
      name: "Secure Background Verification via Government APIs",
      serviceType: "Background Verification",
      provider: {
        "@type": "Organization",
        name: "HireStar.io",
        url: "https://hirestar.io",
      },
      areaServed: {
        "@type": "Country",
        name: "India",
      },
      audience: [
        {
          "@type": "Audience",
          audienceType:
            "Employers and HR professionals seeking background verification services",
        },
        {
          "@type": "Audience",
          audienceType: "Recruitment agencies outsourcing candidate screening",
        },
      ],
      description:
        "Leverage cutting-edge blockchain and AI solutions for fast, reliable, and compliant background verification services.",
      url: "https://hirestar.io/govt-api",
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Government API",
          item: "https://hirestar.io/govt-api",
        },
      ],
    },
  ],
};

export default function Govt_API() {
  // fetch url path
  const location = useLocation();
  let name = location.state?.name;

  // console.log(JSON.stringify(jsonLdData));
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Comprehensive AI-driven & Blockchain Powered Background Verification
          Checks | Hirestar.io
        </title>
        <meta
          name="description"
          content="Explore essential background verification checks for employees and partners. Make informed hiring and partnership decisions."
        />
        <meta
          name="keywords"
          content="background verification, identity checks, employment verification, education verification, address verification, criminal record check, ID verification, degree verification, drug test, financial integrity check, employment verification, 
           tenant registration,din, tin search, gstin, uan verification, epfo verification"
        />

        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />

        <meta property="og:title" content="Government Api Page" />

        <meta
          property="og:description"
          content="Explore essential background verification checks for employees and partners. Make informed hiring and partnership decisions."
        />
        <meta property="og:url" content="https://hirestar.io/govt-api" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={Govt_Image} />
        <meta property="og:image:type" content="image/png" />

        <meta name="robots" content="index, follow" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content=" Comprehensive AI-driven Background Verification Checks | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Explore essential background verification checks for employees and partners. Make informed hiring and partnership decisions."
        />
        <meta name="twitter:image" content={Govt_Image} />
      </Helmet>
      <div className="mb-20 relative  background_color ">
        {/* Image that is hidden on small screens */}
        <img
          loading="lazy"
          src={bg_image}
          title="about-us-bg"
          alt="govt api background img"
          className="absolute  object-cover w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className=" relative  w-full h-full ">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center  mx-1  ">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7 w-full Banking_heading font-semibold font-[poppins] top_spacing">
              <span className="industry_info">
                {name === "Explore All" ? "" : name}
              </span>
              <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                All-in-One AI-Driven Fraud Prevention and Risk Management
              </h1>
              <p className="about-text-para mt-2 w-[80%]">
                Enhance your operations with solutions that comply with
                regulations and foster trust throughout your digital onboarding
                and verification processes.
              </p>

              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative   lg:mt-0 bottom_space">
              <img
                loading="lazy"
                src={Govt_Image}
                title="about girl for govt. api page"
                alt="about_girl img container"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section_spacing1 ">
        <GovtApiCards />
      </div>
      <div className="mb-56">
        <BgvStepsSection />
      </div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
